import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { QuestionBankModel } from '../../models/question-bank.model';
import { DocumentModel } from '../../models/document.model';
import { CompanyAuditService } from '../../services/company-audit.service';
import { CompanyAuditModuleViewModel } from '../../models/company-audit-module-view.model';
import { AccountService } from '../../../core/services/account.service';
import { CompanyUserModel } from 'app/shared/models/company-user.model';
import { ICompanyAuditDetailsModel } from 'app/company-audit/models/company-audit-details.model';
import { Result } from 'app/core/models/result';

@Component({
  selector: 'app-company-audit-module-view',
  templateUrl: './company-audit-module-view.component.html',
  styleUrls: ['./company-audit-module-view.component.css']
})
export class CompanyAuditModuleViewComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    createAuditFrom: FormGroup;
    selectedModules: CompanyAuditModuleViewModel[];
    auditModule: CompanyAuditModuleViewModel;
    submitAttempt: boolean = false;
    auditId: string;
    moduleId: string;
    questionsModel: QuestionBankModel[];
    auditDocuments: DocumentModel[];
    companyUser: CompanyUserModel;
    companyAuditModel: ICompanyAuditDetailsModel;
    pageNumber: number = 0;
    progress: number = 0;
    score: number = 0;
    potentialScore: number = 0;
    totalPercentage: number = 0;
    reportDownloading: boolean = false;
    reportDownloaded: boolean = false;

    constructor(
        private companyAuditService: CompanyAuditService,
        private accountService: AccountService,
        private location: Location,
        private activatedRoute: ActivatedRoute,
        private router: Router
    ) { }

    ngOnInit() {
        this.auditId = this.activatedRoute.snapshot.params['auditId'];
        let moduleId = this.activatedRoute.snapshot.params['moduleId'];
        this.load(moduleId);
    }

    load(moduleId: string) {

        this.moduleId = moduleId;
        this.getModulesForAudit(this.auditId);

        this.companyAuditService.get(this.auditId).subscribe(auditInfo => {
            this.companyAuditModel = auditInfo;
            this.companyAuditService.getAuditModule(this.auditId, this.moduleId).subscribe(auditModule => {
                this.auditModule = auditModule;
                this.headerTitle = {
                    title: auditModule.moduleDescription,
                    breadcrumbs: [
                        { title: 'Company Audits', url: ['/company-audit'] },
                        { title: auditInfo.title, url: ['/company-audit/' + this.auditId] }
                    ]
                };
            });
        });

        this.companyAuditService.getAnswers(this.auditId, this.moduleId).subscribe(
            questions => {
                this.questionsModel = questions;
                this.calculateProgress();
                this.score = this.questionsModel.reduce((sum, current) => sum + current.score, 0);
                this.potentialScore = this.questionsModel.reduce((sum, current) => sum + current.questions.length, 0) * 2;
                this.totalPercentage = Math.round(this.score / this.potentialScore * 100);
            },
            error => this.errors = error.errorList
        );

        // ---------- Load uploaded documents for this module ---------- //
        this.companyAuditService.getDocuments(this.moduleId).subscribe(
            documents => {
                this.auditDocuments = documents;
            },
            error => this.errors = error.errorList
        );

    }

    switchModule(moduleId: string) {
        this.router.navigateByUrl("/company-audit/view/"+this.auditId+"/"+moduleId);
        this.pageNumber = 0;
        this.load(moduleId);
    }

    calculateProgress() {
        this.progress = Math.round(100 / this.questionsModel.length * (this.pageNumber + 1));
    }

    pageUp() {
        this.pageNumber = this.pageNumber + 1;
        this.calculateProgress();
        window.scrollTo(0, 0);
    }

    pageDown() {
        this.pageNumber = this.pageNumber - 1;
        this.calculateProgress();
        window.scrollTo(0, 0);
    }

    onBack(): void {
        this.location.back();
    }


    // Get existing Modules already assigned to Audit following updates
    getModulesForAudit(auditId) {
        this.companyAuditService.getAuditModules(auditId).subscribe(
            modules => {
                this.selectedModules = modules;
            },
            error => {
                this.errors = (<Result>error).errorList;
            });
    }

    downloadReport = (auditCategoryId: number, companyAuditId: string) => {
      this.reportDownloading = true;
      if (auditCategoryId == 1) {
        // Responsible Lending
        this.companyAuditService.downloadReport('responsible-lending-report', companyAuditId).then(() => {
          this.reportDownloaded = true;
          this.reportDownloading = false;
        });
      } else if (auditCategoryId == 2) {
        // General Business Obligations
        this.companyAuditService.downloadReport('business-obligations-report', companyAuditId).then(() => {
          this.reportDownloaded = true;
          this.reportDownloading = false;
        });
      }
    }
}
